import { render, staticRenderFns } from "./Jack.vue?vue&type=template&id=394a284a&"
import script from "./Jack.vue?vue&type=script&lang=js&"
export * from "./Jack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports